import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

type Tag = {
	min: number;
	max: number;
	label: string;
	color: string;
	labelColor: string;
	textColor: string;
};

type Tags = Tag[];

const tagNormalizer = (value: unknown) => {
	const tag = value as Tag;
	const pattern = /^#[a-f0-9]+$/i;
	if (!pattern.test(tag.labelColor) || !pattern.test(tag.textColor)) {
		throw new Error('Expecting color to be a hex code');
	}
	return tag;
};

const tagsListNormalizer = (value: unknown) => {
	const tags = value as Tags;

	if (tags.length === 0) {
		throw new Error('Expecting tags to be a non-empty array.');
	}

	const ascendingOrderTags = tags.sort((a, b) => a.min - b.min);

	if (ascendingOrderTags[0].min !== 0 || ascendingOrderTags[tags.length - 1].max !== 100) {
		throw new Error('Tag ranges must cover values from 0 to 100.');
	}

	ascendingOrderTags.forEach((tag, index) => {
		if (index + 1 >= ascendingOrderTags.length) return;

		const nextTag = ascendingOrderTags[index + 1];
		if (tag.max + 1 !== nextTag.min) {
			if (tag.max + 1 < nextTag.min) {
				throw new Error('Tag ranges must cover values from 0 to 100.');
			}

			if (tag.max + 1 > nextTag.min) {
				throw new Error('Tag ranges cannot overlap.');
			}
		}
	});
	return tags;
};

export const FCM_DM_PROFILE_RESPONSIVENESS_SCORE_CONFIG = defineFcm('dm_profile_responsiveness_score_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				contact: {
					type: 'object',
					shape: {
						email: { type: 'string' },
						phone: { type: 'string' },
					},
				},
				tags: {
					type: 'array',
					optional: true,
					shape: {
						type: 'object',
						shape: {
							min: { type: 'number' },
							max: { type: 'number' },
							label: { type: 'string' },
							color: { type: 'string' },
							labelColor: { type: 'string', optional: true },
							textColor: { type: 'string', optional: true },
						},
						normalizer: tagNormalizer,
					},
					normalizer: tagsListNormalizer,
				},
			},
		}),
	)
	.withDefault({
		contact: {
			email: 'test@change.org',
			phone: 'dummy-phone',
		},
		tags: [{ min: 0, max: 100, label: 'Responsive', color: '#000000', labelColor: '#000000', textColor: '#ffffff' }],
	})
	.toConfig();
